/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { SimpleAction } from './simple-action';
import { MultiActionStep } from './multi-action-step';

export class MultiAction<T> extends SimpleAction<T> {
  get stepIndex(): number {
    return this._stepIndex;
  }
  set step(value: MultiActionStep[]) {
    this._step = value;
    this.updateStep();
  }

  get step(): MultiActionStep[] {
    return this._step;
  }

  public withDropdown: boolean;
  /**
   * Letter on icon action
   */
  pictogram: string;
  private _step: MultiActionStep[] = [];
  private _stepIndex = 0;

  public mainIcon: string;
  public displayedSecondaryIcon: string;
  public mainPictogram: string;

  constructor(
    name: string,
    icon: string,
    text: string,
    secondaryIcon?: string,
    topLine?: boolean,
    bottomLine?: boolean,
    pictogram?: string,
    step?: MultiActionStep[],
    align?: 'left' | 'center' | 'right'
  ) {
    super(name, icon, null, text);
    this.category = 'multi';
    this.secondaryIcon = secondaryIcon;
    this.topLine = topLine;
    this.bottomLine = bottomLine;
    this.pictogram = pictogram;
    this._step = step;
    if (align) {
      this.align = align;
    }
    this.updateStep();
  }

  /**
   * @deprecated
   * Use category property
   */
  override getActionType(): string {
    return 'multi';
  }

  public changeIndex(index: number) {
    if (this._step && this._step.length > index) {
      this._stepIndex = index;
      this.updateStep();
    }
  }

  public nextStep() {
    if (this._step && this._step.length > 0) {
      this._stepIndex++;
      if (this._stepIndex >= this._step.length) {
        this._stepIndex = 0;
      }
    }
    this.updateStep();
  }

  /**
   * update mainIcon, displayedSecondaryIcon and mainPictogram from index
   */
  public updateStep() {
    if (this._step) {
      if (this._step[this._stepIndex].icon) {
        this.mainIcon = this._step[this._stepIndex].icon;
      } else {
        this.mainIcon = this.icon;
      }
      if (this._step[this._stepIndex].secondaryIcon) {
        this.displayedSecondaryIcon = this._step[this._stepIndex].secondaryIcon;
      } else {
        this.displayedSecondaryIcon = this.secondaryIcon;
      }
      if (this._step[this._stepIndex].pictogram) {
        this.mainPictogram = this._step[this._stepIndex].pictogram;
      } else {
        this.mainPictogram = this.pictogram;
      }
    }
  }

  public count(): number {
    return this._step.length;
  }
}
